import classNames from "classnames";
import { twMerge } from "tailwind-merge";

type Size = "sm" | "md";
type Color = "red" | "purple";

type Props = {
  className?: string;
  animate?: boolean;
  size?: Size;
  color?: Color;
};

const sizeClasses: Record<Size, string> = {
  sm: "h-2 w-2 ring-1",
  md: "h-2.5 w-2.5 ring-2",
};

const colorClasses: Record<Color, string> = {
  red: "bg-red-600 ring-red-300",
  purple: "bg-purple-600 ring-purple-300",
};

const Indicator = ({ className, animate = true, size = "md", color = "red" }: Props) => (
  <span
    data-testid="indicator"
    className={twMerge(
      "block rounded-full border border-white",
      sizeClasses[size],
      colorClasses[color],
      classNames({ "animate-scaleIn": animate }),
      className,
    )}
  />
);

export default Indicator;
